import { render, staticRenderFns } from "./UserTrailPage.vue?vue&type=template&id=0ccb16d0"
import script from "./UserTrailPage.vue?vue&type=script&lang=js"
export * from "./UserTrailPage.vue?vue&type=script&lang=js"
import style0 from "./UserTrailPage.vue?vue&type=style&index=0&id=0ccb16d0&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports